<template>
  <a-spin :spinning="loading">
    <div class="d-flex align-items-center justify-content-between mb-3">
      <div class="d-flex align-items-center">
        <h2 class="mr-3">Testing</h2>
        <!-- <a-tag :color="courseData.statusPublication === 'published' ? 'green' : 'orange'">{{courseData.statusPublication === 'published' ? 'TERPUBLIKASI': 'DRAF'}}</a-tag> -->
      </div>
      <!-- <div>
        <a-button @click.prevent="" type="danger">
          <LeftSquareOutlined />
          Batal</a-button
        >
      </div> -->
    </div>
    <a-card>
      <a-row class="mt-4" :gutter="[32, 32]">
        <a-col :span="24" class="d-flex justify-content-between align-items-center">
          <!-- <a-button @click="$router.back()"><LeftOutlined />Back</a-button>
          <a-button @click="changeEdittable">
            <span v-if="!editable"> <FormOutlined class="mr-2" />Edit </span>
            <span v-else> <EyeOutlined class="mr-2" />View </span>
          </a-button> -->
        </a-col>
        <a-col :span="24">
          <div>
            <h1 class="text-title">Date</h1>
          </div>
          <div>
            <a-row :gutter="[24, 12]">
              <a-col :sm="{ span: 6 }">
                <a-date-picker
                  format="DD / MM / YYYY"
                  class=" w-100"
                  v-model:value="dataPayload.date"
                ></a-date-picker>
              </a-col>
            </a-row>
          </div>
        </a-col>
        <!-- <a-col :span="24">
          <div>
            <h1 class="text-title">Customer & Location</h1>
          </div>
          <div>
            <a-row :gutter="[24, 12]">
              <a-col :xs="{ span: 24 }" :sm="{ span: 8 }">
                <div class="w-100">
                  <p style="text-align: left;" class="text-label">Customer</p>
                  <a-select
                    placeholder="Pilih Customer"
                    class="w-100"
                    v-model:value="selectedCustomer"
                    @change="handleChangeCustomer"
                  >
                    <a-select-option
                      v-for="(item, index) in dataCustomers"
                      :key="index"
                      :value="item.id"
                      >{{ item.name }}</a-select-option
                    >
                  </a-select>
                </div>
              </a-col>
              <a-col :xs="{ span: 24 }" :sm="{ span: 8 }">
                <div class="w-100">
                  <p style="text-align: left;" class="text-label">Location</p>
                  <a-select
                    placeholder="Pilih Lokasi"
                    class="w-100"
                    v-model:value="selectedLocation"
                    @change="handleChangeLocation"
                    :disabled="!selectedCustomer"
                  >
                    <a-select-option
                      v-for="(item, index) in dataLocation"
                      :key="index"
                      :value="item.id"
                      >{{ item.name }}</a-select-option
                    >
                  </a-select>
                </div>
              </a-col>
              <a-col :xs="{ span: 24 }" :sm="{ span: 8 }">
                <div class="w-100">
                  <p style="text-align: left;" class="text-label">Room</p>
                  <a-select
                    placeholder="Pilih Room"
                    class="w-100"
                    v-model:value="selectedRoom"
                    @change="handleChangeRoom"
                    :disabled="!selectedLocation"
                  >
                    <a-select-option
                      v-for="(item, index) in dataRoom"
                      :key="index"
                      :value="item.id"
                      >{{ item.name }}</a-select-option
                    >
                  </a-select>
                </div>
              </a-col>
            </a-row>
          </div>
        </a-col> -->
        <a-col :span="24">
          <div>
            <h1 class="text-title">Tester Detail</h1>
          </div>
          <a-row :gutter="[24, 12]">
            <a-col
              :span="24"
              class="d-flex justify-content-between  align-items-center"
              style="gap: 15px;"
            >
              <div class="w-100">
                <p style="text-align: left;" class="text-label">Name</p>
              </div>
              <div class="w-100">
                <p style="text-align: left;" class="text-label">Title</p>
              </div>
              <div class="w-100">
                <p style="text-align: left;" class="text-label">Company</p>
              </div>
              <div class="w-100"></div>
            </a-col>
            <a-col
              :span="24"
              class="d-flex justify-content-between  align-items-center"
              style="gap: 15px;"
              v-for="(item, index) in installerDetailData"
              :key="index"
            >
              <div class="w-100">
                <a-input v-model:value="item.name" placeholder="Masukkan Nama"></a-input>
              </div>
              <div class="w-100">
                <a-input v-model:value="item.title" placeholder="Masukkan Title"></a-input>
              </div>
              <div class="w-100">
                <a-select class="w-100" placeholder="Pilih Company" v-model:value="item.vendorId">
                  <a-select-option
                    v-for="(itemV, indexV) in dataVendors"
                    :key="indexV"
                    :value="itemV.id"
                    >{{ itemV.name }}</a-select-option
                  >
                </a-select>
              </div>
              <div class="w-100">
                <a-button
                  @click="deleteInstallerDetail(item._id)"
                  type="danger"
                  :disabled="item.id"
                >
                  <DeleteOutlined />
                </a-button>
              </div>
            </a-col>
            <a-col :span="24">
              <a-button @click="addInstallerDetail">
                <PlusOutlined />
              </a-button>
            </a-col>
          </a-row>
        </a-col>

        <a-col :span="24">
          <div>
            <h1 class="text-title">Aset Detail</h1>
          </div>
          <div>
            <a-row :gutter="[24, 12]">
              <a-col :span="24">
                <h2 class="text-subtitle">Aset Information</h2>
                <a-divider></a-divider>
              </a-col>
              <a-col :xs="{ span: 24 }" :sm="{ span: 8 }">
                <div class="w-100">
                  <p style="text-align: left;" class="text-label">Asset Category</p>
                  <a-select
                    placeholder="Pilih Asset Category"
                    class="w-100"
                    v-model:value="selectedCategories"
                    @change="handleChangeCategories"
                    disabled
                  >
                    <a-select-option
                      v-for="(item, index) in dataAssetCategories"
                      :key="index"
                      :value="item.id"
                      >{{ item.name }}</a-select-option
                    >
                  </a-select>
                </div>
              </a-col>
              <a-col :xs="{ span: 24 }" :sm="{ span: 8 }">
                <div class="w-100">
                  <p style="text-align: left;" class="text-label">Asset Sub Category</p>
                  <a-select
                    placeholder="Pilih Asset Sub Category"
                    class="w-100"
                    v-model:value="selectedSubCategories"
                    @change="handleChangeSubCategories"
                    disabled
                  >
                    <a-select-option
                      v-for="(item, index) in dataAssetSubCategories"
                      :key="index"
                      :value="item.id"
                      >{{ item.name }}</a-select-option
                    >
                  </a-select>
                </div>
              </a-col>
              <a-col :xs="{ span: 24 }" :sm="{ span: 8 }" v-if="selectedRequestType != 'Addition'">
                <div class="w-100">
                  <p style="text-align: left;" class="text-label">Asset</p>
                  <a-select
                    placeholder="Pilih Asset"
                    class="w-100"
                    v-model:value="selectedAsset"
                    @change="handelChangeAssets"
                    disabled
                  >
                    <a-select-option
                      v-for="(item, index) in dataAssets"
                      :key="index"
                      :value="item.id"
                      >{{ item.name }}</a-select-option
                    >
                  </a-select>
                </div>
              </a-col>
              <!--  -->
              <!--  -->
              <a-col :xs="{ span: 24 }" :sm="{ span: 8 }" v-if="selectedRequestType != 'Addition'">
                <div class="w-100">
                  <p style="text-align: left;" class="text-label">Brand</p>
                  <a-select
                    placeholder="Pilih Manufacturer"
                    class="w-100"
                    v-model:value="dataSelectedAsset.manufacturerId"
                    disabled
                  >
                    <a-select-option
                      v-for="(item, index) in dataManufatures"
                      :key="index"
                      :value="item.id"
                      >{{ item.name }}</a-select-option
                    >
                  </a-select>
                </div>
              </a-col>
              <a-col :xs="{ span: 24 }" :sm="{ span: 8 }" v-if="selectedRequestType != 'Addition'">
                <p style="text-align: left;" class="text-label">Model</p>
                <a-input
                  placeholder="Masukkan Model"
                  v-model:value="dataSelectedAsset.modelAsset"
                  disabled
                ></a-input>
              </a-col>
              <a-col :xs="{ span: 24 }" :sm="{ span: 8 }" v-if="selectedRequestType != 'Addition'">
                <p style="text-align: left;" class="text-label">Product No</p>
                <a-input
                  placeholder="Masukkan Product No"
                  v-model:value="dataSelectedAsset.productNumber"
                  disabled
                ></a-input>
              </a-col>
              <a-col :xs="{ span: 24 }" :sm="{ span: 8 }" v-if="selectedRequestType != 'Addition'">
                <p style="text-align: left;" class="text-label">Serial No</p>
                <a-input
                  placeholder="Masukkan Serial No"
                  v-model:value="dataSelectedAsset.serialNumber"
                  disabled
                ></a-input>
              </a-col>
              <a-col :xs="{ span: 24 }" :sm="{ span: 8 }" v-if="selectedRequestType != 'Addition'">
                <p style="text-align: left;" class="text-label">Service Tag</p>
                <a-input
                  placeholder="Masukkan Service Tag"
                  v-model:value="dataSelectedAsset.serviceTag"
                  disabled
                ></a-input>
              </a-col>
              <a-col :xs="{ span: 24 }" :sm="{ span: 8 }" v-if="selectedRequestType != 'Addition'">
                <p style="text-align: left;" class="text-label">Asset Tag</p>
                <a-input
                  placeholder="Masukkan Asset Tag"
                  v-model:value="dataSelectedAsset.assetTag"
                  disabled
                ></a-input>
              </a-col>
            </a-row>
            <a-row :gutter="[24, 12]" class="mt-5">
              <a-col :span="24">
                <h2 class="text-subtitle">Procurement Information</h2>
                <a-divider></a-divider>
              </a-col>
              <a-col :sm="{ span: 8 }" :xs="{ span: 12 }">
                <p class="text-label">Tanggal Pembelian</p>
                <!-- <a-input  placeholder="Masukkan System Name"></a-input> -->
                <a-date-picker
                  v-model:value="dataPayload.procurements.purchaseDate"
                  format="DD / MM / YYYY"
                  class=" w-100"
                  disabled
                ></a-date-picker>
              </a-col>
              <a-col :span="12">
                <p class="text-label">Nomor Pembelian</p>
                <a-input
                  placeholder="Masukkan Nomor Pembelian"
                  v-model:value="dataPayload.procurements.No"
                  disabled
                ></a-input>
              </a-col>
              <a-col :sm="{ span: 8 }" :xs="{ span: 12 }">
                <p class="text-label">Garansi</p>
                <a-input
                  placeholder="Masukkan Garansi"
                  suffix="Month(s)"
                  v-model:value="dataPayload.procurements.warranty"
                  disabled
                ></a-input>
              </a-col>
              <a-col :sm="{ span: 8 }" :xs="{ span: 12 }">
                <p class="text-label">Garansi Mulai</p>
                <!-- <a-input  placeholder="Masukkan DNS"></a-input> -->
                <a-date-picker
                  format="DD / MM / YYYY"
                  class=" w-100"
                  v-model:value="dataPayload.procurements.warrantyStart"
                  disabled
                ></a-date-picker>
              </a-col>
              <a-col :sm="{ span: 8 }" :xs="{ span: 12 }">
                <p class="text-label">Garansi Berakhir</p>
                <!-- <a-input  placeholder="Masukkan IP Address"></a-input> -->
                <a-date-picker
                  format="DD / MM / YYYY"
                  class=" w-100"
                  v-model:value="dataPayload.procurements.warrantyEnd"
                  disabled
                ></a-date-picker>
              </a-col>
              <a-col :span="12">
                <p class="text-label">Vendor</p>
                <!-- <a-input  placeholder="Masukkan OS / Nomor Serial"></a-input> -->
                <a-select
                  placeholder="Pilih Vendor"
                  class="w-100"
                  v-model:value="dataPayload.procurements.vendorId"
                  @change="handleChangeProcurementVendor"
                  disabled
                >
                  <a-select-option
                    v-for="(item, index) in dataVendors"
                    :key="index"
                    :value="item.id"
                    >{{ item.name }}</a-select-option
                  >
                </a-select>
              </a-col>
              <a-col :xs="{ span: 12 }" :sm="{ span: 8 }">
                <p class="text-label">Email</p>
                <a-input
                  disabled
                  placeholder="Masukkan Email"
                  v-model:value="dataPayload.procurements.email"
                ></a-input>
              </a-col>
              <a-col :xs="{ span: 12 }" :sm="{ span: 8 }">
                <p class="text-label">Nomor Telepon</p>
                <a-input
                  disabled
                  placeholder="Masukkan Nomor Telepon"
                  v-model:value="dataPayload.procurements.mobileNumber"
                ></a-input>
              </a-col>
            </a-row>
            <a-row :gutter="[24, 12]" class="mt-5">
              <a-col :span="24">
                <h2 class="text-subtitle">Maintenance Information</h2>
                <a-divider></a-divider>
              </a-col>
              <a-col :sm="{ span: 8 }" :xs="{ span: 12 }">
                <p class="text-label">Tanggal Kontrak</p>
                <!-- <a-input  placeholder="Masukkan System Name"></a-input> -->
                <a-date-picker
                  format="DD / MM / YYYY"
                  class=" w-100"
                  v-model:value="dataPayload.maintenances.purchaseDate"
                  disabled
                ></a-date-picker>
              </a-col>
              <a-col :span="12">
                <p class="text-label">Nomor Kontrak</p>
                <a-input
                  placeholder="Masukkan Nomor Kontrak"
                  v-model:value="dataPayload.maintenances.No"
                  disabled
                ></a-input>
              </a-col>
              <a-col :sm="{ span: 8 }" :xs="{ span: 12 }">
                <p class="text-label">Garansi</p>
                <a-input
                  placeholder="Masukkan Garansi"
                  suffix="Month(s)"
                  v-model:value="dataPayload.maintenances.warranty"
                  disabled
                ></a-input>
              </a-col>
              <a-col :sm="{ span: 8 }" :xs="{ span: 12 }">
                <p class="text-label">Garansi Mulai</p>
                <!-- <a-input  placeholder="Masukkan DNS"></a-input> -->
                <a-date-picker
                  format="DD / MM / YYYY"
                  class=" w-100"
                  v-model:value="dataPayload.maintenances.warrantyStart"
                  disabled
                ></a-date-picker>
              </a-col>
              <a-col :sm="{ span: 8 }" :xs="{ span: 12 }">
                <p class="text-label">Garansi Berakhir</p>
                <!-- <a-input  placeholder="Masukkan IP Address"></a-input> -->
                <a-date-picker
                  format="DD / MM / YYYY"
                  class=" w-100"
                  v-model:value="dataPayload.maintenances.warrantyEnd"
                  disabled
                ></a-date-picker>
              </a-col>
              <a-col :span="12">
                <p class="text-label">Vendor</p>
                <!-- <a-input  placeholder="Masukkan OS / Nomor Serial"></a-input> -->
                <a-select
                  placeholder="Pilih Vendor"
                  class="w-100"
                  v-model:value="dataPayload.maintenances.vendorId"
                  @change="handleChangeMaintenancesVendor"
                  disabled
                >
                  <a-select-option
                    v-for="(item, index) in dataVendors"
                    :key="index"
                    :value="item.id"
                    >{{ item.name }}</a-select-option
                  >
                </a-select>
              </a-col>
              <a-col :xs="{ span: 12 }" :sm="{ span: 8 }">
                <p class="text-label">Email</p>
                <a-input
                  disabled
                  placeholder="Masukkan Email"
                  v-model:value="dataPayload.maintenances.email"
                ></a-input>
              </a-col>
              <a-col :xs="{ span: 12 }" :sm="{ span: 8 }">
                <p class="text-label">Nomor Telepon</p>
                <a-input
                  disabled
                  placeholder="Masukkan Nomor Telepon"
                  v-model:value="dataPayload.maintenances.mobileNumber"
                ></a-input>
              </a-col>
            </a-row>
            <a-row :gutter="[24, 12]" class="mt-5" v-if="false">
              <a-col :span="24">
                <h2 class="text-subtitle">Tecnical Information</h2>
                <a-divider></a-divider>
              </a-col>
              <a-col :span="8">
                <p class="text-label">System Name</p>
                <a-input :disabled="!editable" placeholder="Masukkan System Name"></a-input>
              </a-col>
              <a-col :span="8">
                <p class="text-label">Host Name</p>
                <a-input :disabled="!editable" placeholder="Masukkan Host Name"></a-input>
              </a-col>
              <a-col :span="8">
                <p class="text-label">Domain Role</p>
                <a-input :disabled="!editable" placeholder="Masukkan Domain Role"></a-input>
              </a-col>
              <a-col :span="6">
                <p class="text-label">DNS</p>
                <a-input :disabled="!editable" placeholder="Masukkan DNS"></a-input>
              </a-col>
              <a-col :span="6">
                <p class="text-label">IP Address</p>
                <a-input :disabled="!editable" placeholder="Masukkan IP Address"></a-input>
              </a-col>
              <a-col :span="12">
                <p class="text-label">OS / Nomor Serial</p>
                <a-input :disabled="!editable" placeholder="Masukkan OS / Nomor Serial"></a-input>
              </a-col>
            </a-row>
          </div>
        </a-col>
        <a-col :span="24">
          <div>
            <h1 class="text-title">Testing Remarks</h1>
          </div>
          <a-row :gutter="[24, 12]">
            <a-col :xs="{ span: 24 }" :sm="{ span: 7 }" :span="7">
              <p class="text-label">Testing Reason</p>
              <!-- <a-input placeholder="Masukkan Type of Failure"></a-input> -->
              <a-select
                placeholder="Pilih Testing Reason"
                v-model:value="dataPayload.testingReason"
                class="w-100"
              >
                <!-- <a-select-option :key="1000" :value="null">Pilih</a-select-option> -->
                <a-select-option
                  v-for="(item, index) in dataTestingReason"
                  :key="index"
                  :value="item"
                  >{{ item }}</a-select-option
                >
              </a-select>
            </a-col>
            <a-col :xs="{ span: 24 }" :sm="{ span: 7 }" :span="7">
              <p class="text-label">Status of Product</p>
              <!-- <a-input placeholder="Masukkan Type of Solving"></a-input> -->
              <a-select
                placeholder="Pilih Status of Product"
                v-model:value="dataPayload.productStatus"
                class="w-100"
              >
                <!-- <a-select-option :key="1000" :value="null">Pilih</a-select-option> -->
                <a-select-option
                  v-for="(item, index) in dataStatusofProduct"
                  :key="index"
                  :value="item"
                  >{{ item }}</a-select-option
                >
              </a-select>
            </a-col>
            <a-col :xs="{ span: 24 }" :sm="{ span: 7 }" :span="7">
              <p class="text-label">Other Product Status</p>
              <a-input
                placeholder="Masukkan Other Product Status"
                v-model:value="dataPayload.otherProductStatus"
              ></a-input>
            </a-col>
            <a-col :xs="{ span: 24 }" :sm="{ span: 7 }">
              <div class="d-flex justify-content-between align-item-center w-100 my-2">
                <div class="d-flex align-items-center" style="gap:10px">
                  <p class="m-0">1.</p>
                  <p class="m-0">Need DC Offline</p>
                </div>

                <a-radio-group
                  class="d-flex align-items-center"
                  style="gap:10px"
                  v-model:value="dataPayload.needDcOffline"
                >
                  <a-radio :value="true">Yes</a-radio>
                  <a-radio :value="false">No</a-radio>
                </a-radio-group>
              </div>
              <!-- <p class="text-label">Explain</p>
              <a-textarea placeholder="Masukkan Explain"></a-textarea> -->
            </a-col>
            <a-col :xs="{ span: 24 }" :sm="{ span: 7 }">
              <p class="text-label">Test Duration</p>
              <a-input
                placeholder="Masukkan Test Duration"
                v-model:value="dataPayload.testDuration"
              ></a-input>
              <!-- <p class="text-label">Explain</p>
              <a-textarea placeholder="Masukkan Explain"></a-textarea> -->
            </a-col>
          </a-row>
        </a-col>
        <a-col :span="24">
          <a-row :gutter="[24, 12]">
            <a-col :xs="{ span: 24 }" :sm="{ span: 8 }">
              <p class="text-label">Tanggal Selesai</p>
              <a-date-picker
                format="DD/MM/YYYY"
                class="w-100"
                v-model:value="dataPayload.tanggal_selesai"
                placeholder="Pilih Tanggal Selesai"
                :disabled="status === 'Completed' && !editable"
              ></a-date-picker>
            </a-col>
          </a-row>
        </a-col>
        <a-col :span="24">
          <a-row :gutter="[24, 12]">
            <a-col :span="18"></a-col>
            <a-col :span="6" class="d-flex justify-content-end align-items-center" style="gap:15px">
              <a-button @click="$router.back()">Cancel</a-button>
              <a-button
                v-if="status !== 'Completed'"
                @click="handleSaveAsDraft"
                :loading="loadingDraft"
              >
                Save as Draft
              </a-button>
              <a-button @click="handleSubmit" type="primary" :loading="loadingSubmit">
                {{ status === 'In Progress' ? 'Complete' : 'Submit' }}
              </a-button>
            </a-col>
          </a-row>
        </a-col>
      </a-row>
    </a-card>
  </a-spin>
</template>

<script>
import { onMounted, ref, createVNode, computed, onBeforeMount } from 'vue'
import { defineAsyncComponent } from 'vue'
import { useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'
import {
  PlusOutlined,
  LoadingOutlined,
  DeleteOutlined,
  ExclamationCircleOutlined,
  LeftSquareOutlined,
  FormOutlined,
  EyeOutlined,
} from '@ant-design/icons-vue'
import { message, Modal, notification } from 'ant-design-vue'
import { getOne, remove, getAllPendings, update } from '@/services/axios/brivice-backend'
import apiClient from '@/services/axios'
import assetsFile from '@/data/modc_dump.json'
import moment from 'moment'
import { uniqueId } from 'lodash'
import { getAllUser } from '../../services/axios/modc/user'
import { getAssetCategory, getAssets, getCategories } from '../../services/axios/modc/assets'
import { getManufactures } from '../../services/axios/modc/manufacture'
import {
  getChangeRequestById,
  getListAdditionQuestion,
  // editOrCreateAddition,
  editOrCreateTesting,
} from '../../services/axios/modc/helpdesk'

import { getVendors } from '../../services/axios/modc/vendor'
import {
  getCustomers,
  getLocations,
  getRooms,
  getLocationByCustomerId,
  getRoomByCustomerId,
} from '../../services/axios/modc/customer'

const columns = [
  {
    title: 'Nama Perangkat',
    dataIndex: 'device',
    key: 'device',
    slots: { customRender: 'device' },
    width: '15%',
  },
  {
    title: 'Nama Brand',
    dataIndex: 'brand',
    key: 'brand',
    slots: { customRender: 'brand' },
  },
  {
    title: 'Nomor Produk',
    dataIndex: 'productNo',
    key: 'productNo',
    slots: { customRender: 'productNo' },
  },
  {
    title: 'Nomor Serial',
    dataIndex: 'serialNo',
    key: 'serialNo',
    slots: { customRender: 'serialNo' },
  },
]

export default {
  components: { DeleteOutlined, PlusOutlined },
  setup() {
    let store = useStore()
    let route = useRoute()
    let router = useRouter()
    const assets = ref()
    const manufactures = ref()
    const catFacility = ref('Access Point')
    const facility = ref('Access-002')
    const selectedTestingReason = ref()
    const selectedStatusofProduct = ref()
    const selectedReparation = ref()
    const dataTestingReason = [
      'New Installation',
      'Drill/Simulation',
      'Post Reparation',
      // 'Part Failure',
      // 'Broken Part',
      // 'Other',
    ]
    const dataTestingRemark = ref([])
    const dataStatusofProduct = ['New', 'Existing', 'Other']
    const dataReparation = ['Minor', 'Major', 'Overhaul', 'Other']
    const editable = ref(false)
    const installerDetailData = ref([])
    const loading = ref(false)
    const status = ref('')
    const loadingDraft = ref(false)
    const loadingSubmit = ref(false)

    const dataManufatures = ref([])
    const selectedManufatures = ref()

    const dataVendors = ref([])
    const selectedVendors = ref()
    const selectedVendors2 = ref()

    const selectedRequestType = ref()

    const dataSelectionRequester = ref([])
    const selectedSelectionRequester = ref()
    const selectedDataRequester = ref({})

    const dataAssetCategories = ref([])
    const selectedCategories = ref()

    const dataAssetSubCategories = ref([])
    const selectedSubCategories = ref()

    const dataAssets = ref([])
    const selectedAsset = ref()

    const dataAnswersReq = ref([])

    // CUSTOMER
    const selectedCustomer = ref()
    const dataCustomers = ref([])
    const selectedLocation = ref()
    const dataLocation = ref([])
    const selectedRoom = ref()
    const dataRoom = ref([])

    const dataPayload = ref({
      wifiName: null,
      availablePort: null,
      workingPort: null,
      deadPort: null,
      ipAdress: null,
      subnetMask: null,
      gateway: null,
      totalPort: null,
      systemName: null,
      hostName: null,
      domainRole: null,
      dns: null,
      os: null,
      softwareName: null,
      softwareVersion: null,
      accessType: null,
      airFlow: null,
      coolingDesign: null,
      coolingType: null,
      coolingCapacity: null,
      inputPowerKw: null,
      panelType: null,
      transferSwitch: null,
      phaseType: null,
      sensorType: null,
      supressType: null,
      fillDate: null,
      expireDate: null,
      extenguisherType: null,
      kva: null,
      kw: null,
      machineType: null,
      systemTrigger: null,
      model: null,
      formFactor: null,
      battery: null,
      height: null,
      width: null,
      depth: null,
      weight: null,
      backupKw: null,
      backupKva: null,
      backupDuration: null,
      inputKw: null,
      inputKva: null,
      outputKw: null,
      outputKva: null,
      batteryType: null,
      voltage: null,
      cells: null,
      controllerStatus: null,
      utpType: null,
      node: null,
      connectionType: null,
      patch: null,
      cableManagement: null,
      rackUnit: null,
      crossConnection: null,
      foType: null,
      softwareType: null,
      version: null,
      customerId: null,
      locationId: null,
      roomId: null,
      assetSubCategoryId: null,
      manufacturerId: null,
      vendorId: null,
      name: null,
      modelAsset: null,
      productNumber: null,
      serialNumber: null,
      serviceTag: null,
      assetTag: null,
      rackNumber: null,
      uNumber: null,
      uSize: null,
      status: null,
      diskDrives: [
        // {
        //   model: 'Disk Drive Model 1',
        //   serialNumber: 'SN1234567890A',
        //   capacity: '128 GB',
        // },
      ],
      memories: [
        // {
        //   model: 'Memory Model 1',
        //   serialNumber: 'SN1234567890A',
        //   capacity: '128 GB',
        // },
      ],
      processors: [
        // {
        //   model: 'Processor Model 1',
        //   speed: '3.6 GHz',
        //   threads: 6,
        //   cores: 6,
        // },
      ],
      procurements: {
        vendorId: null,
        purchaseDate: null,
        No: null,
        Date: null,
        value: null,
        warranty: null,
        warrantyStart: null,
        warrantyEnd: null,
      },
      maintenances: {
        vendorId: null,
        purchaseDate: null,
        No: null,
        Date: null,
        value: null,
        warranty: null,
        warrantyStart: null,
        warrantyEnd: null,
      },

      date: null,
      requestId: null,
      approverId: null,
      testingReason: null,
      productStatus: null,
      otherProductStatus: null,
      needDcOffline: null,
      testDuration: null,
      reparation: null,
      explaination: null,
      additionId: null,
      installers: [
        // {
        //   id: 4,
        //   name: 'Ahmad',
        //   title: 'Tukang',
        //   vendorId: 1,
        // },
        // {
        //   name: 'Ahmad Abdul Azis',
        //   title: 'Tukang',
        //   vendorId: 1,
        // },
      ],
      answers: [
        // {
        //   id: 5,
        //   idQuestion: 1,
        //   answer: 'no',
        // },
      ],
      tanggal_selesai: null,
    })
    const dataSelectedAsset = ref({
      manufacturerId: null,
      modelAsset: null,
      productNumber: null,
      serialNumber: null,
      serviceTag: null,
      assetTag: null,
    })
    const handleChangeSelectedRequester = e => {
      if (e) {
        selectedDataRequester.value = dataSelectionRequester.value.find(data => data.id == e)
        dataPayload.value.approverId = e
      }
    }
    const addInstallerDetail = () => {
      installerDetailData.value.push({ _id: uniqueId('add-'), name: '', title: '', vendorId: null })
    }
    const deleteInstallerDetail = id => {
      installerDetailData.value = installerDetailData.value.filter(trb => trb._id !== id)
    }
    onBeforeMount(() => {
      getInitialData()
    })
    // created() {

    // }
    const getInitialData = async () => {
      // loading.value = true
      console.log('masih')
      const resUser = await getAllUser()
      dataSelectionRequester.value = resUser.users
      const customers = await getCustomers()
      dataCustomers.value = customers.customer
      const resChangeRequest = await getChangeRequestById(route.params.id)
      console.log(resChangeRequest, '<<<<<HALLO')

      // Get status dari change request
      status.value = resChangeRequest.rqDetail.status

      const categories = await getCategories()
      const assetCategory = await getAssetCategory()
      const filteredAssetCategory = assetCategory.categories.filter(
        cat => cat.name != 'Software' && cat.name != 'Infrastructure' && cat.name != 'Monitoring',
      )
      const {
        AssetSubCategory,
        Customer,
        HardwareInformation,
        Location,
        Manufacturer,
        Room,
        TechnicalActiveDevice,
        TechnicalFacility,
        TechnicalPassiveDevice,
        TechnicalSoftware,
        ProcurementInformation,
        MaintenanceInformation,
        Components,
        ...rest
      } = resChangeRequest.rqDetail.Asset
      let catAssets

      const manufactures = await getManufactures()
      dataManufatures.value = manufactures.manufacturers

      const vendors = await getVendors()
      console.log('ini vendor', TechnicalActiveDevice, '<<<<<')
      dataVendors.value = vendors.vendor

      selectedRequestType.value = resChangeRequest.rqDetail.type

      status.value = resChangeRequest.rqDetail.status
      console.log('masuk?')

      await handleChangeRequestType(resChangeRequest.rqDetail.type)
      selectedCategories.value = resChangeRequest.rqDetail.Asset
        ? resChangeRequest.rqDetail.Asset.AssetSubCategory.assetCategoryId
        : null
      await handleChangeCategories(
        resChangeRequest.rqDetail.Asset
          ? resChangeRequest.rqDetail.Asset.AssetSubCategory.assetCategoryId
          : null,
      )
      selectedSubCategories.value = resChangeRequest.rqDetail.Asset
        ? resChangeRequest.rqDetail.Asset.AssetSubCategory.id
        : null
      await handleChangeSubCategories(
        resChangeRequest.rqDetail.Asset
          ? resChangeRequest.rqDetail.Asset.AssetSubCategory.id
          : null,
      )
      selectedAsset.value = resChangeRequest.rqDetail.Asset.id
      await handelChangeAssets(resChangeRequest.rqDetail.Asset.id)

      // dataPayload.value.tbMasterId = resChangeRequest.rqDetail.TestingMasters.length
      dataPayload.value.additionId = resChangeRequest.rqDetail.TestingMasters.length
        ? resChangeRequest.rqDetail.TestingMasters[0].id
        : null
      dataPayload.value.date = resChangeRequest.rqDetail.TestingMasters.length
        ? moment(resChangeRequest.rqDetail.TestingMasters[0].date)
        : null

      dataPayload.value.testingReason = resChangeRequest.rqDetail.TestingMasters.length
        ? resChangeRequest.rqDetail.TestingMasters[0].TestingRemark.testingReason
        : null
      dataPayload.value.productStatus = resChangeRequest.rqDetail.TestingMasters.length
        ? resChangeRequest.rqDetail.TestingMasters[0].TestingRemark.productStatus
        : null
      dataPayload.value.otherProductStatus = resChangeRequest.rqDetail.TestingMasters.length
        ? resChangeRequest.rqDetail.TestingMasters[0].TestingRemark.otherProductStatus
        : null
      // dataPayload.value.reparation = resChangeRequest.rqDetail.TestingMasters.length
      //   ? resChangeRequest.rqDetail.TestingMasters[0].TestingRemark.reparation
      //   : null
      installerDetailData.value = resChangeRequest.rqDetail.TestingMasters.length
        ? resChangeRequest.rqDetail.TestingMasters[0].TestingInstallers
        : []
      dataPayload.value.approverId = resChangeRequest.rqDetail.TestingMasters.length
        ? resChangeRequest.rqDetail.TestingMasters[0].approverId
        : null
      selectedSelectionRequester.value = resChangeRequest.rqDetail.TestingMasters.length
        ? resChangeRequest.rqDetail.TestingMasters[0].approverId
        : null

      await handleChangeSelectedRequester(
        resChangeRequest.rqDetail.TestingMasters.length
          ? resChangeRequest.rqDetail.TestingMasters[0].approverId
          : null,
      )

      // dataPayload.value.answers = resChangeRequest.rqDetail.TestingMasters.length
      //   ? resChangeRequest.rqDetail.TestingMasters[0].TestingRemark.AdditionAnswers.length
      //     ? resChangeRequest.rqDetail.TestingMasters[0].TestingRemark.AdditionAnswers
      //     : []
      //   : []
      // dataAnswersReq.value = resChangeRequest.rqDetail.TestingMasters.length
      //   ? resChangeRequest.rqDetail.TestingMasters[0].TestingRemark.AdditionAnswers.length
      //     ? resChangeRequest.rqDetail.TestingMasters[0].TestingRemark.AdditionAnswers
      //     : []
      //   : []

      dataPayload.value.procurements = resChangeRequest.rqDetail.Asset
        ? resChangeRequest.rqDetail.Asset.ProcurementInformation
        : dataPayload.value.procurements
      dataPayload.value.maintenances = resChangeRequest.rqDetail.Asset
        ? resChangeRequest.rqDetail.Asset.MaintenanceInformation
        : dataPayload.value.maintenances

      // const testingRemarkData = await getListAdditionQuestion()
      // dataTestingRemark.value = testingRemarkData.question
      // console.log(testingRemarkData, '<<<<<HALLO')
      selectedCustomer.value = rest.customerId
      handleChangeCustomer(rest.customerId)
      selectedLocation.value = rest.locationId
      handleChangeLocation(rest.locationId)
      selectedRoom.value = rest.roomId
      // selectedManufatures.value = Manufacturer.id
      dataPayload.value = {
        ...dataPayload.value,
        customerId: String(rest.customerId),
        locationId: String(rest.locationId),
        roomId: String(rest.roomId),
        assetSubCategoryId: String(AssetSubCategory.id),
        name: rest.name,
        manufacturerId: String(rest.manufactureId),
        modelAsset: rest.model,
        testingId: resChangeRequest.rqDetail.TestingMasters.length
          ? resChangeRequest.rqDetail.TestingMasters[0].id
          : null,
        needDcOffline: resChangeRequest.rqDetail.TestingMasters.length
          ? resChangeRequest.rqDetail.TestingMasters[0].TestingRemark.needDcOffline
          : null,
        testDuration: resChangeRequest.rqDetail.TestingMasters.length
          ? resChangeRequest.rqDetail.TestingMasters[0].TestingRemark.testDuration
          : null,
        productNumber: rest.productNumber,
        serialNumber: rest.serialNumber,
        serviceTag: rest.serviceTag,
        assetTag: rest.assetTag,
        rackNumber: rest.rackNumber,
        uNumber: rest.uNumber,
        uSize: rest.uSize,
        procurements: {
          ...ProcurementInformation,
        },
        maintenances: {
          ...MaintenanceInformation,
        },
        ...TechnicalActiveDevice,
        ...TechnicalFacility,
        ...TechnicalPassiveDevice,
        ...TechnicalSoftware,
        ...Components,
        cableManagement: TechnicalPassiveDevice?.cableManagement,
        crossConnection: TechnicalPassiveDevice?.crossConnection,
      }
      loading.value = false
    }

    // CUSTOMER
    const handleChangeCustomer = async e => {
      const location = await getLocationByCustomerId(e)
      dataLocation.value = location.locations
      dataPayload.value.customerId = e
    }
    const handleChangeLocation = async e => {
      const room = await getRoomByCustomerId(selectedCustomer.value, e)
      // console.log(room)
      dataRoom.value = room.rooms
      dataPayload.value.locationId = e
    }
    const handleChangeRoom = async e => {
      dataPayload.value.roomId = e
    }

    const handleChangeRequestType = async e => {
      const assetCategory = await getAssetCategory()
      const filteredAssetCategory = assetCategory.categories.filter(
        cat => cat.name != 'Software' && cat.name != 'Infrastructure' && cat.name != 'Monitoring',
      )
      const lastAssetCategory = filteredAssetCategory.filter(cat => {
        if (e == 'Troubleshooting') {
          if (cat.name != 'Passive Devices') return cat
        } else return cat
      })
      dataAssetCategories.value = lastAssetCategory
      dataPayload.value.type = e
      // dataAssetSubCategories.value = lastAssetCategory
    }
    const handleChangeCategories = async e => {
      if (e) {
        const subCategories = dataAssetCategories.value.find(cat => cat.id == e)
        console.log(
          dataAssetCategories.value.find(cat => cat.id == e),
          '<<<<HALO',
        )
        dataAssetSubCategories.value = subCategories.AssetSubCategories
      }
    }
    const handleChangeSubCategories = async e => {
      if (e) {
        const assets = await getAssets({ type: e })
        dataAssets.value = assets.assets
        dataPayload.value.assetSubCategoryId = e
      }
    }

    const handelChangeAssets = async e => {
      const assets = dataAssets.value.find(asset => asset.id == e)
      dataPayload.value.assetId = assets.id
      dataSelectedAsset.value = assets
      console.log(assets, '<<<ASSETs')
    }

    const changeEdittable = () => {
      editable.value = !editable.value
    }
    const handleChangeProcurementVendor = async e => {
      const vendorProcurement = dataVendors.value.find(data => data.id == e)
      dataPayload.value.procurements.email = vendorProcurement.email
      dataPayload.value.procurements.mobileNumber = vendorProcurement.mobileNumber
    }
    const handleChangeMaintenancesVendor = async e => {
      const vendorMaintenance = dataVendors.value.find(data => data.id == e)
      dataPayload.value.maintenances.email = vendorMaintenance.email
      dataPayload.value.maintenances.mobileNumber = vendorMaintenance.mobileNumber
    }

    // Save as Draft (Status: In Progress)
    const handleSaveAsDraft = async () => {
      loadingDraft.value = true
      try {
        dataPayload.value.installers = installerDetailData.value
        dataPayload.value.requestId = route.params.id

        const payload = {
          ...dataPayload.value,
          isDraft: true, // Key untuk save as draft
        }

        const data = await editOrCreateTesting(payload)

        if (data) {
          notification.success({
            message: 'Draft Berhasil Disimpan',
            description: 'Data Testing disimpan sebagai draft (In Progress)',
          })
          // Redirect ke list page setelah save draft
          router.push({ name: 'Testing' })
        } else {
          notification.error({
            message: 'Server Error',
            description: 'Gagal menyimpan draft',
          })
        }
      } catch (error) {
        console.error('Error saving draft:', error)
        notification.error({
          message: 'Error',
          description: 'Terjadi kesalahan saat menyimpan draft',
        })
      } finally {
        loadingDraft.value = false
      }
    }

    // Complete/Submit (Status: Completed)
    const handleSubmit = async () => {
      loadingSubmit.value = true
      try {
        dataPayload.value.installers = installerDetailData.value
        dataPayload.value.requestId = route.params.id

        const payload = dataPayload.value
        const data = await editOrCreateTesting(payload)

        if (data) {
          notification.success({
            message: 'Berhasil Submit',
            description:
              status.value === 'In Progress'
                ? 'Data Testing Berhasil Diselesaikan'
                : 'Data Testing Berhasil di Submit',
          })
        } else {
          notification.error({
            message: 'Server Error',
            description: 'Internal Server Error',
          })
        }

        router.push({ name: 'Testing' })
      } catch (error) {
        console.error('Error submitting:', error)
        notification.error({
          message: 'Error',
          description: 'Terjadi kesalahan saat submit',
        })
      } finally {
        loadingSubmit.value = false
      }
    }
    const handleChangeAnswerRemark = (e, item, index) => {
      console.log(item.id)
      dataPayload.value.answers[index] = {
        // "id": 5,
        ...dataPayload.value.answers[index],
        idQuestion: item.id,
        answer: e.target.value,
      }
    }

    return {
      loading,
      loadingDraft,
      loadingSubmit,
      status,
      columns,
      // detail troubleshoot
      facility,
      catFacility,
      installerDetailData,
      // Last Section
      dataTestingReason,
      dataStatusofProduct,
      dataReparation,
      selectedReparation,
      selectedTestingReason,
      selectedStatusofProduct,
      editable,
      dataTestingRemark,

      changeEdittable,

      addInstallerDetail,
      deleteInstallerDetail,
      handleSubmit,
      handleSaveAsDraft,
      // dataSource,

      dataPayload,
      dataSelectedAsset,
      dataVendors,
      selectedVendors,
      selectedVendors2,
      selectedRequestType,
      dataSelectionRequester,
      selectedSelectionRequester,
      selectedDataRequester,
      dataAssetCategories,
      selectedCategories,
      dataAssetSubCategories,
      selectedSubCategories,
      dataAssets,
      selectedAsset,
      dataManufatures,
      selectedManufatures,

      handleChangeCategories,
      handleChangeSubCategories,
      handelChangeAssets,
      handleChangeAnswerRemark,
      handleChangeProcurementVendor,
      handleChangeMaintenancesVendor,
      handleChangeSelectedRequester,
      dataAnswersReq,

      // CUSTOMER
      selectedCustomer,
      dataCustomers,
      selectedLocation,
      dataLocation,
      selectedRoom,
      dataRoom,
      handleChangeCustomer,
      handleChangeLocation,
      handleChangeRoom,
      getInitialData,
      // status,
    }
  },
}
</script>
<style lang="scss">
@import '../styleViews.scss';

.text-title {
  font-size: 1.5rem;
  color: $black;
  font-weight: 500;
  margin-bottom: 10px;
}

.text-subtitle {
  font-size: 1.3rem;
  color: $black;
  font-weight: 500;
  margin-bottom: 10px;
}

.text-label {
  font-size: 1rem;
  color: $text;
  font-weight: 400;
  margin-bottom: 10px;
}

.th-upload-wrapper {
  .ant-upload-picture-card-wrapper {
    display: flex;
    justify-content: center;

    .ant-upload {
      width: 300px;
      height: 100px;
    }
  }
}
</style>
